import * as React from "react";
import { forwardRef } from "react";
const SvgDownload = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 14, height: 16, viewBox: "0 0 14 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M6.99961 12C7.29961 12 7.49961 11.9 7.69961 11.7L13.3996 6L11.9996 4.6L7.99961 8.6V0H5.99961V8.6L1.99961 4.6L0.599609 6L6.29961 11.7C6.49961 11.9 6.69961 12 6.99961 12Z", fill: "#219CD0" }), /* @__PURE__ */ React.createElement("path", { d: "M14 14H0V16H14V14Z", fill: "#219CD0" }));
const ForwardRef = forwardRef(SvgDownload);
export { ForwardRef as ReactComponent };
